"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useSettingsSnapshot_1 = require("../hooks/useSettingsSnapshot");
const AdvancedSettingsPanel_1 = require("./AdvancedSettingsPanel");
const RuneScapeButton_1 = require("./RuneScapeButton");
const RuneScapePanel_1 = require("./RuneScapePanel");
function DefaultSidebar({ children, style, ...props }) {
    const settings = (0, useSettingsSnapshot_1.useSettingsSnapshot)();
    const [advancedSettingsOpen, setAdvancedSettingsOpen] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("aside", { id: "right_panel", ...props, style: {
                    display: settings.menuVisible ? "flex" : "none",
                    flex: "0 0 auto",
                    flexDirection: "column",
                    height: "100%",
                    minWidth: 0,
                    overflowY: "auto",
                    width: 240,
                    ...style,
                }, children: (0, jsx_runtime_1.jsxs)(RuneScapePanel_1.RuneScapePanel, { style: { boxSizing: "border-box", flexShrink: 0, minHeight: "100%", width: "100%" }, children: [(0, jsx_runtime_1.jsx)("div", { children: children }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsx)(RuneScapeButton_1.RuneScapeButton, { onClick: () => setAdvancedSettingsOpen(true), style: { width: "100%" }, type: "button", children: "Advanced settings" })] })] }) }), (0, jsx_runtime_1.jsx)(AdvancedSettingsPanel_1.AdvancedSettingsPanel, { onClose: () => setAdvancedSettingsOpen(false), open: advancedSettingsOpen })] }));
}
exports.DefaultSidebar = DefaultSidebar;
